/* Dezine Kids — move bottom collection description below filters + products. */
(function () {
  function moveBottomCollectionDescription() {
    var collectionRow = document.getElementById('Collection');
    if (!collectionRow) return;

    var description = collectionRow.querySelector('.collection-description-section');
    if (!description) return;

    var oldWrapper = document.querySelector('[data-dk-collection-description-fullwidth="true"]');
    if (oldWrapper) {
      if (!oldWrapper.contains(description)) oldWrapper.appendChild(description);
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'page-width collection-description-fullwidth';
    wrapper.setAttribute('data-dk-collection-description-fullwidth', 'true');

    if (collectionRow.classList.contains('fullwidth')) {
      wrapper.classList.add('fullwidth');
    }

    wrapper.style.width = '100%';
    wrapper.style.clear = 'both';

    collectionRow.parentNode.insertBefore(wrapper, collectionRow.nextSibling);
    wrapper.appendChild(description);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveBottomCollectionDescription);
  } else {
    moveBottomCollectionDescription();
  }
})();
